module.exports = __webpack_public_path__ + "media/images/home/shutterstock-63d784c00e28f9987f1c0bfe0b62b29d.jpg";